<div class="form-check"
     [ngClass]="{
        'form-check-inline': props.formCheck === 'inline' || props.formCheck === 'inline-switch',
        'form-switch': props.formCheck === 'switch' || props.formCheck === 'inline-switch'
      }">
       <input type="checkbox"
              [class.is-invalid]="showError"
              class="form-check-input"
              [class.position-static]="props.formCheck === 'nolabel'"
              [indeterminate]="props.indeterminate && formControl.value == null"
              [formControl]="formControl"
              [formlyAttributes]="field" />
       <label *ngIf="props.formCheck !== 'nolabel'"
              [attr.for]="id"
              class="form-check-label">
              {{ props.label }}
              <span *ngIf="props.required && props.hideRequiredMarker !== true"
                    aria-hidden="true"
                    class="text-danger">*</span>
       </label>
</div>